const initialState = {
  loading: 0,
  error: null,
  breadcrumbs: [],
  currentPage: null,
};

// selector
export const isLoading = state => state.loading !== 0;

// action names
export const SET_BREADCRUMBS = '[APP] breadcrumbs';
export const CHANGE_PAGE = '[APP] page';

// action creators
export const setBreadcrumbs = breadcrumbs => ({
  type: SET_BREADCRUMBS,
  payload: breadcrumbs,
});
export const changePage = pageName => ({
  type: CHANGE_PAGE,
  payload: pageName,
});

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CHANGE_PAGE:
      return { ...state, currentPage: action.payload };
    case SET_BREADCRUMBS:
      return { ...state, breadcrumbs: action.payload };
    default:
      return withLoading(state, action);
  }
}

function withLoading(state, action) {
  if (action.request) {
    return { ...state, loading: state.loading + 1, error: null };
  } else if (action.success) {
    return { ...state, loading: state.loading - 1, error: null };
  } else if (action.error) {
    return { ...state, error: action.payload, loading: state.loading - 1 };
  } else {
    return state;
  }
}
